import { getDropdownOptions } from "helpers/DropdownHelper";
import { NotificationSeverity, NotificationSeverityTranslation } from "modules/common";
import React from "react";
import { Filter, ToggleSwitch } from "..";

interface Props {
    onChange: (severity: NotificationSeverity) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: NotificationSeverity[];
}

export const SeverityFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const renderFilter = () => {
        return getDropdownOptions(NotificationSeverityTranslation).map(option => (
            <div key={option.value}>
                <ToggleSwitch
                    value={option.value.toString()}
                    checked={value.includes(option.value)}
                    onChange={() => onChange(option.value)}
                    htmlFor={option.label}
                    text={
                        <div className="filter__item__text">{option.label.toLocaleUpperCase()}</div>
                    }
                />
            </div>
        ));
    };

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="VRSTA PORUKE"
        >
            {renderFilter()}
        </Filter>
    );
};
